import React from "react";

function Footer() {
  return (
    <>
      <footer className="footer">
        <p>© 2024 Madhu Shree Satta Matka. All rights reserved.</p>
      </footer>
    </>
  );
}

export default Footer;
